import { FunctionComponent } from "react";
import { Message } from "@bigcommerce/big-design";
import { ErrorMessageObject } from "../../types/messages";
import { StyledMessageBox } from "./styled";
import { useQueryClient } from "@tanstack/react-query";


const WErrorMessage: FunctionComponent = () => {
    const queryClient = useQueryClient();
    const errorMessage = queryClient.getQueryData<ErrorMessageObject>(["errorMessage"]);
    const description = errorMessage?.description;
    const messages = errorMessage?.messages || [];

    if (!description && !messages.length) {
        return null;
    }

    const handleClose = () =>{
        queryClient.resetQueries(["errorMessage"]);
    }

    return (
        <StyledMessageBox>
            <Message
                messages={[
                    { text: description || "" },
                    ...messages?.map((message) => ({ text: message })),
                ]}
                onClose={handleClose}
                type="error"
            />
        </StyledMessageBox>
    );
};

export default WErrorMessage;
